import { OnboardingType } from 'models/lead.model'
import type { TPlansDecorations } from 'models/plan-decoration.model'

export const PLANS_DECORATIONS_INTL_1T: TPlansDecorations = {
  USD: {
    [OnboardingType.PURCHASE]: [
      {
        name: 'plan1',
        isDefault: true,
        decoratedPrice: '$1.00',
        decoratedStrikethroughPrice: '$29.99',
        title: 'Try **Intellio IQ** for 7 days',
        totalPriceText: '$1.00',
        trialBadgeText: '7-day trial',
        subscriptionPriceText: '$29.99 per month',
        periodIntervalForSubscriptionDescription: '1 month',
        introBillingPeriod: '7-day',
        billingSubscriptionPeriod: 'monthly',
        discountBadgeText: '95%',
        analyticsPrice: 29.99,
        analyticsTrialPrice: 1,
        analyticsProductName: 'intellio_USD_1_mo_29.99_intro_7_days_1.00',
        productPrice: '1.00+29.99',
      },
    ],
  },
}
